import React, { useState } from 'react';
import { Button, Icon } from '@economic/taco';
import { Trans, t } from '@lingui/macro';
import { PartialInvoiceDto } from '~/types/internal-api';
import { SalesDocument } from '../../types';
import PartialInvoicesTable from './PartialInvoicesTable';
import PartialInvoicingBalanceInfo from './PartialInvoicingBalanceInfo';

interface Props {
    openedInCreatePartialInvoiceDialog: boolean;
    order: SalesDocument;
    partialInvoices: PartialInvoiceDto[];
}

export default function ExistingPartialInvoicesInfo({ openedInCreatePartialInvoiceDialog, order, partialInvoices }: Props) {
    const [collapseExistingInvoicesTable, setCollapseExistingInvoicesTable] = useState(openedInCreatePartialInvoiceDialog);

    const partialInvoicesAmountSum = partialInvoices.reduce((sum, el) => sum + el.amount, 0);
    const orderRemainingAmount = order.amount - partialInvoicesAmountSum;

    return (
        <>
            <strong>
                {openedInCreatePartialInvoiceDialog ? (
                    <div className={`flex items-center ${!collapseExistingInvoicesTable ? 'mb-4' : ''}`}>
                        <Button
                            onClick={() => setCollapseExistingInvoicesTable(!collapseExistingInvoicesTable)}
                            appearance="transparent">
                            <Icon name={collapseExistingInvoicesTable ? 'chevron-right' : 'chevron-down'} />
                            <Trans>Existing partial invoices on this order</Trans>{' '}
                        </Button>
                    </div>
                ) : (
                    <div className="mb-2">
                        <Trans>Existing partial invoices on order no. {order.number}</Trans>
                    </div>
                )}
            </strong>
            {!collapseExistingInvoicesTable && (
                <>
                    <div className="max-h-[200px] flex-grow overflow-y-auto flex flex-shrink flex-col">
                        <PartialInvoicesTable data={partialInvoices} />
                    </div>
                    <PartialInvoicingBalanceInfo
                        textGroups={[
                            { label: t`Total order amount`, value: order.amount },
                            { label: t`Partial invoices sum`, value: partialInvoicesAmountSum },
                            { label: t`Remaining amount`, value: orderRemainingAmount },
                        ]}
                    />
                </>
            )}
        </>
    );
}
